// What the task pane says when a sync will give tasks new Unique IDs (GID-261).
//
// The backend builds the notice while staging the sync (bridge_sync.uid_notice,
// see backend/services/sync_uid_notice.py) and says what will happen and why.
// This decides how loud to be. A rebuild is about one sync in three in prod, so
// explaining every one would soon go unread: the first rebuild in a chat gets
// the full explanation, later ones one line. A rebuild because the plan changed
// in Project (emphasis "warn") is always explained.
//
// Kept out of taskpane.js (which cannot be imported in tests) so the wording
// and the once-per-chat rule are unit-tested.

const KINDS = new Set(["rebuild", "moved_rows"]);

/** Remembers, per chat, whether the full rebuild explanation was shown. */
export function createUidNoticeTracker() {
  const explained = new Set();

  return {
    /**
     * @param {{kind: string, emphasis?: string, message: string, detail?: string}|null} notice
     * @param {string|null} sessionId  the chat the sync belongs to
     * @returns {string|null}
     */
    textFor(notice, sessionId) {
      if (!notice || !KINDS.has(notice.kind) || !notice.message) return null;
      if (notice.kind === "moved_rows") return `ℹ ${notice.message}`;

      const full = notice.emphasis === "warn" || !sessionId || !explained.has(sessionId);
      if (sessionId) explained.add(sessionId);
      if (!full) return `ℹ ${notice.message}`;
      return notice.detail ? `⚠ ${notice.message} ${notice.detail}` : `⚠ ${notice.message}`;
    },
  };
}
